<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style  rel="stylesheet/scss" lang="scss" >
.el-input__inner {
  height: 33px;
  font-size: 13px;
  box-shadow: none;
  border: 1px solid #e9e9e9;
  background: white;
  padding: 0 6px;
}
.el-input__inner:focus {
  border-color: #42a5f5;
  box-shadow: none;
  transition-duration: 0.5s;
}
.el-input__inner::-webkit-input-placeholder {
  line-height: 20px;
}
.el-input.is-disabled .el-input__inner {
  color: black;
}
.el-badge__content {
  background-color: #3a8ee6;
}

.el-collapse-item__content,
.el-collapse-item__header {
  background-color: #c4d0e2;
}

.el-tree-node:focus > .el-tree-node__content {
  background-color: #5daaf0;
}

.odd_row {
  background-color: #dce2f0;
}

.even_row {
  background-color: #f5f7fa;
}

.txt-number {
  width: 86px;
}
.txt-select {
  width: 86px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}

/* 弹出框定义 */
.el-dialog__header {
  padding: 6px 10px 6px 10px;
  .header {
    padding: 8px 8px 8px 8px;
  }
  .el-dialog__title {
    font-size: 13px;
    font-weight: bold;
  }
}

.el-dialog__body {
  padding: 6px 10px 6px 10px;
}

/* card */
.el-card {
  .el-card__header {
    padding: 5px;
    .title {
      font-size: 12px;
      line-height: 28px;
      font-weight: bold;
      color: #606266;
    }
    .el-button {
      padding: 6px 0px 6px 0px;
    }
  }
  .el-card__body {
    padding: 0px 20px;
    background-color: #c4d0e2;
    .el-collapse-item__wrap {
      border-bottom: 0px solid #ebeef5;
      .el-collapse-item__content {
        padding-bottom: 0px;
      }
    }
  }
}

.el-tabs {
  .el-tabs__header {
    margin: 0px 0px 1px 0px;
  }
  .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #c4d0e2;
  }

  .el-tabs__item {
    background-color: #c4d0e2;
  }
  .is-active {
    background-color: #c4d0e2;
    font-weight: bold;
    background-color: #fcd692;
  }
  // .el-icon-close { display:none;}

  .el-tabs__content {
    background-color: #c4d0e2;
  }
}

/* 禁用样式定义 */
.el-input.is-disabled .el-input__inner {
  background-color: #e6e6e6;
  cursor: auto;
}

.el-select .el-input.is-disabled .el-input__inner {
  background-color: #e6e6e6;
  cursor: auto;
}

.el-textarea.is-disabled .el-textarea__inner {
  background-color: #e6e6e6;
  color: #000000;
  cursor: auto;
}

.el-radio__input.is-disabled + span.el-radio__label {
  color: #606266;
  cursor: auto;
}

.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #606266;
  cursor: auto;
}

// 不用 :inline="true"
.el-form-item {
  width: 252px;
  float: left;

  .el-form-item__label {
    font-weight: normal;
  }
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-top: 4px;
  margin-bottom: 8px;
}

.el-radio + .el-radio {
  margin-left: 0px;
}

.app-wrapper {
  min-width: 1480px; //为了出现滚动条，覆盖width:100%;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-thumb {
  border-radius: 3px !important;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.6) !important;
}
::-webkit-scrollbar-track {
  border-radius: 3px !important;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
  //background: #f1f1f1 !important;
}
.el-message__content{
  b{font-size: 15px;display: inline-block;margin-bottom: 6px;}
}
</style>



// WEBPACK FOOTER //
// src/App.vue